"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BILL_SIDEBAR_NODES = void 0;
/** 费用中心侧栏（`/llm/bill/*`），权限由路由侧 filterMenus / filterNavTree 处理。 */
exports.BILL_SIDEBAR_NODES = [
    {
        id: 'bill-account-overview',
        type: 'group',
        menuKey: 'accountOverview',
        msg: 'nav.bill.accountOverview',
        children: [
            {
                id: 'bill-account-overview-leaf',
                menuKey: 'accountOverview',
                msg: 'nav.bill.accountOverview',
                path: '/llm/bill/account-overview',
                permission: 'bill_bill_list',
            },
        ],
    },
    {
        id: 'bill-fund',
        type: 'group',
        menuKey: 'fundManage',
        msg: 'nav.bill.fundManage',
        children: [
            {
                id: 'bill-funds',
                menuKey: 'transactionDetail',
                msg: 'nav.bill.transactionDetail',
                path: '/llm/bill/funds',
                permission: 'bill_fund_list',
            },
            {
                id: 'bill-recharge',
                menuKey: 'rechargeRemit',
                msg: 'nav.bill.rechargeRemit',
                path: '/llm/bill/recharge',
                permission: 'bill_balance_update',
            },
            {
                id: 'bill-history',
                menuKey: 'transactionHistory',
                msg: 'nav.bill.transactionHistory',
                path: '/llm/bill/history',
                permission: 'bill_fund_list',
            },
        ],
    },
    {
        id: 'bill-order',
        type: 'group',
        menuKey: 'orderManage',
        msg: 'nav.bill.orderManage',
        children: [
            {
                id: 'bill-my-order',
                menuKey: 'myOrder',
                msg: 'nav.bill.myOrder',
                path: '/llm/bill/bills',
                permission: 'bill_bill_list',
            },
        ],
    },
    {
        id: 'bill-manage',
        type: 'group',
        menuKey: 'billManage',
        msg: 'nav.bill.billManage',
        children: [
            {
                id: 'bill-overview',
                menuKey: 'billOverview',
                msg: 'nav.bill.billOverview',
                path: '/llm/bill/overview',
                permission: 'bill_bill_list',
            },
            {
                id: 'bill-detail',
                menuKey: 'billDetail',
                msg: 'nav.bill.billDetail',
                path: '/llm/bill/cycle',
                permission: 'bill_bill_list',
            },
            {
                id: 'bill-cost',
                menuKey: 'costBill',
                msg: 'nav.bill.costBill',
                path: '/llm/bill/cost-report',
                permission: 'bill_bill_list',
            },
            {
                id: 'bill-usage',
                menuKey: 'resourceUsage',
                msg: 'nav.bill.resourceUsage',
                path: '/llm/bill/usage',
                permission: 'bill_bill_list',
            },
        ],
    },
    {
        id: 'bill-invoice',
        type: 'group',
        menuKey: 'invoiceManage',
        msg: 'nav.bill.invoiceManage',
        children: [
            {
                id: 'bill-invoices',
                menuKey: 'invoices',
                msg: 'nav.bill.invoices',
                path: '/llm/bill/invoice',
                permission: 'bill_bill_list',
            },
        ],
    },
    {
        id: 'bill-user-rights',
        type: 'group',
        menuKey: 'userRights',
        msg: 'nav.bill.userRights',
        children: [
            {
                id: 'bill-coupons',
                menuKey: 'couponCenter',
                msg: 'nav.bill.couponCenter',
                path: '/llm/bill/coupons',
                permission: 'bill_bill_list',
            },
        ],
    },
    {
        id: 'bill-admin',
        type: 'group',
        menuKey: 'adminManage',
        msg: 'nav.bill.adminManage',
        children: [
            {
                id: 'bill-admin-recharge',
                menuKey: 'accountRecharge',
                msg: 'nav.bill.accountRecharge',
                path: '/llm/bill/admin-recharge',
                permission: 'bill_admin_list',
            },
            {
                id: 'bill-admin-bills',
                menuKey: 'adminOrderManage',
                msg: 'nav.bill.adminOrderManage',
                path: '/llm/bill/admin-bills',
                permission: 'bill_admin_list',
            },
            {
                id: 'bill-admin-products',
                menuKey: 'adminProductManage',
                msg: 'nav.bill.adminProductManage',
                path: '/llm/bill/admin-products',
                permission: 'bill_admin_list',
            },
            {
                id: 'bill-admin-promotions',
                menuKey: 'productPromotionManage',
                msg: 'nav.bill.productPromotionManage',
                path: '/llm/bill/admin-promotions',
                permission: 'bill_admin_list',
            },
            {
                id: 'bill-admin-coupons',
                menuKey: 'couponManage',
                msg: 'nav.bill.couponManage',
                path: '/llm/bill/admin-coupons',
                permission: 'bill_admin_list',
            },
            {
                id: 'bill-admin-invoice',
                menuKey: 'invoiceManageAdmin',
                msg: 'nav.bill.invoiceManageAdmin',
                path: '/llm/bill/admin-invoice',
                permission: 'bill_admin_list',
            },
        ],
    },
];
